<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>My Message</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-0">

  <mat-tab-group>
    <mat-tab label="Message">
      <div class="container-fluid p-3">
        <b>Date</b>
        <p>{{ (message.date_modified * 1000) | timezoneConvertMedium }}</p>

        <ng-container *ngIf="message.reply_to.id">
          <b>Sender</b>
          <p>
            {{ message.reply_to.contact_person }} <br>
            {{ message.reply_to.employer.name }}
          </p>
        </ng-container>

        <b>Subject</b>
        <p>{{ message.subject }}</p>

        <div [innerHTML]="message.message"></div>
      </div>
    </mat-tab>

    <mat-tab label="Attachments" *ngIf="message.files.length > 0">

      <mat-list>
        <div class="row p-0 m-0">
          <mat-list-item *ngFor="let file of message.files; let i = index; last as isLast" >
            <img matListItemAvatar class="rounded-0" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [src]="file.url" [alt]="file.name">
            <div matListItemTitle class="text-wrap" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"> {{ file.name }} </div>
            <div matListItemLine> {{( file.date_created * 1000) | timezoneConvertMedium }} </div>

            <button
              matListItemMeta
              mat-icon-button
              ngxClipboard
              aria-label="Copy file URL"
              matTooltip="Copy this file URL."
              [cbContent]="file.url"
              (click)="onCopiedURL()"
              class="dialog-button my-auto ml-2 mr-0"
              style="cursor: pointer;">
              <mat-icon>content_copy</mat-icon>
            </button>

            <button
              matListItemMeta
              mat-icon-button
              aria-label="Download file"
              matTooltip="Download this file."
              (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"
              class="dialog-button my-auto ml-2 mr-0"
              style="cursor: pointer;">
              <mat-icon>download</mat-icon>
            </button>

            <button
              matListItemMeta
              mat-icon-button
              aria-label="Preview file"
              matTooltip="View this file."
              (click)="onOpenUrl(file.url)"
              class="dialog-button my-auto ml-2 mr-0"
              style="cursor: pointer;">
              <mat-icon>preview</mat-icon>
            </button>

            <mat-divider class="w-100 m-0" [inset]="true" *ngIf="!isLast"></mat-divider>
          </mat-list-item>
        </div>
      </mat-list>

    </mat-tab>

    <mat-tab label="Recipients">

      <div class="container-fluid p-0">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <span class="mr-auto"> </span>

          <form class="form-inline mx-1 my-0" (ngSubmit)="messageRecipientListDataSource.getData(true)">
            <input
              class="form-control ml-0 mr-2 my-1"
              type="search"
              [(ngModel)]="messageRecipientListDataSource.search"
              name="search"
              placeholder="Search"
              aria-label="Search"
              id="search-input"
              matTooltip="Search for recipients by name or employer." />

            <button
              mat-raised-button
              color="secondary"
              type="submit"
              class="mx-0 my-1"
              id="search-button"
              matTooltip="Click this button to run the current search.">
              <mat-icon>search</mat-icon> Search
            </button>
          </form>
        </nav>

        <div class="mat-elevation-z8 scroll-box">
          <mat-paginator #paginator1 [length]="messageRecipientListDataSource?.total | async" [pageSize]="messageRecipientListDataSource.limit" [pageSizeOptions]="messageRecipientListDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

          <table mat-table [dataSource]="messageRecipientListDataSource">

            <ng-container matColumnDef="contact_person">
              <th mat-header-cell *matHeaderCellDef>
                Full Name
              </th>
              <td mat-cell *matCellDef="let user">
                {{ user.contact_person }}
              </td>
            </ng-container>

            <ng-container matColumnDef="employer">
              <th mat-header-cell *matHeaderCellDef>
                Employer
              </th>
              <td mat-cell *matCellDef="let user">
                {{ user.employer.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="is_read">
              <th mat-header-cell *matHeaderCellDef>
                Opened
              </th>
              <td mat-cell *matCellDef="let user">
                {{ user.pivot.is_read ? 'Yes' : 'No' }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="messageRecipientListHeaders"></tr>
            <tr mat-row *matRowDef="let row; columns: messageRecipientListHeaders"></tr>
          </table>

          <mat-paginator #paginator2 [length]="messageRecipientListDataSource?.total | async" [pageSize]="messageRecipientListDataSource.limit" [pageSizeOptions]="messageRecipientListDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
        </div>
      </div>

    </mat-tab>
  </mat-tab-group>

</mat-dialog-content>
